"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const sha256_1 = __importDefault(require("crypto-js/sha256"));
const event_agent_1 = require("./utils/event.agent");
const uuid_1 = require("./utils/uuid");
/** The event tracker class that handles sending monitoring events. */
class EventTracker {
    /**
     * Create an event tracker instance.
     * @param authService - OIDC AuthService instance.
     * @param [appName] - The application name.
     * @param [sendEvent] - The event agent sender function.
     */
    constructor(authService, appName, sendEvent = event_agent_1.sendDatahub) {
        this.appName = appName;
        this.authService = authService;
        this.origin = window.location.origin;
        this.sendEvent = sendEvent;
        this.uuid = uuid_1.UUID;
    }
    /**
     * Get and normalize the user data.
     * @param [userData] - the current user data object.
     * @returns a Promise with a normalized user data.
     */
    getUserData(userData) {
        var _a, _b, _c, _d, _e, _f, _g;
        return __awaiter(this, void 0, void 0, function* () {
            const user = userData || (yield this.authService.getUser());
            if (!user)
                return;
            return {
                at: sha256_1.default(user.access_token).toString(),
                clientId: (_a = user.profile) === null || _a === void 0 ? void 0 : _a.client_id,
                exp: user.expires_at,
                iat: (_b = user.profile) === null || _b === void 0 ? void 0 : _b.auth_time,
                isAdmin: !!((_c = user.profile) === null || _c === void 0 ? void 0 : _c.adminId),
                isAttendant: !!((_d = user.profile) === null || _d === void 0 ? void 0 : _d.attendantId),
                sid: (_e = user.profile) === null || _e === void 0 ? void 0 : _e.sid,
                tgt: sha256_1.default((_f = user.profile) === null || _f === void 0 ? void 0 : _f.jti).toString(),
                ucode: (_g = user.profile) === null || _g === void 0 ? void 0 : _g.ucode
            };
        });
    }
    /**
     * Set event level.
     * @param level - event level
     */
    setLevel(level) {
        this.level = level;
    }
    /**
     * Set event origin.
     * @param reason - event reason
     */
    setOrigin(origin) {
        this.origin = origin;
    }
    /**
     * Set event reason.
     * @param reason - event reason
     */
    setReason(reason) {
        this.reason = reason;
    }
    /**
     * Send event for monitoring application.
     * @param name - event name
     * @param [payload] - event payload
     * @param [user] - current user data
     */
    send(name, payload, user) {
        return __awaiter(this, void 0, void 0, function* () {
            const userData = yield this.getUserData(user);
            this.sendEvent(Object.assign(Object.assign(Object.assign({ name, level: this.level, origin: this.origin, reason: this.reason, appName: this.appName, appRoute: window.location.pathname + window.location.search, clientId: this.authService.userManager.settings._client_id, referrer: window.location.origin }, userData), payload), { uuid: this.uuid }));
        });
    }
}
exports.default = EventTracker;
